import { deleteParticipant } from "api/participant_delete";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import onDeleteMutation from "utils/onDeleteMutation";

const useDeleteParticipant = (participantLastSearch: string, name: string | undefined) => {
  const navigate = useNavigate();

  const { mutate } = useMutation({
    mutationFn: deleteParticipant,
    onSuccess: (response) =>
      onDeleteMutation({
        response,
        href: `/participant/${participantLastSearch}`,
        navigate,
        successMessage: `Контрагент ${name ? `"${name}" ` : ""}удален`
      })
  });

  return mutate;
};

export default useDeleteParticipant;
